import { useState } from "react";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList, yearOptions } from "@/mocks/animeData";

export default function NewReleases() {
  const [year, setYear] = useState<number>(yearOptions[0]);
  const list = animeList.filter((a) => a.year === year);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-secondary-700">
              <i className="ri-calendar-line"></i> By Year
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">按年份 · 新番速递</h2>
            <p className="mt-2 text-sm text-foreground-600">切换年份，快速回看那一年的年度之番。</p>
          </div>
          <div className="flex flex-wrap gap-2">
            {yearOptions.map((y) => (
              <button
                key={y}
                type="button"
                onClick={() => setYear(y)}
                className={`inline-flex h-9 items-center whitespace-nowrap rounded-full px-4 text-sm font-medium transition-colors ${
                  year === y
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
                }`}
              >
                {y}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {list.slice(0, 4).map((a) => (
            <AnimeCard key={a.id} anime={a} />
          ))}
        </div>
      </div>
    </section>
  );
}